import React from "react";
import Container from "./Container.js";

export default props => (
	<form ref={props.form} onSubmit={props.onSubmit}>
		<Container {...props} />
	</form>
);
